import { ServiceNote } from './service-note';

export class ItemGroupNoteMap {
    id: number;
    serviceGroupId: number;
    serviceItemId: number;
    serviceNote: ServiceNote;
}